import el from 'element-ui/lib/locale/lang/ja';

/* eslint-disable */
export default {
  topbar: {
    faq: 'FAQ',
    guide: '初めての方へ',
    exchange_rate: '為替レート',
  },
  nav: {
    home: 'Home',
    proxyBuy: 'Proxy',
    shop: 'Shops',
    forwarding: '転送',
  },
  ...el,
}
